import React from 'react'
import { replaceBadges } from 'lib/badges'
import ProductInfoConnector, { ConnectorProps as ProductInfoProps } from '../../connectors/ProductsMetaInfo'
import { Badges, Badge } from '../styles/products'

export default ProductInfoConnector((props: ProductInfoProps) => {
  const { badges, clickArtistBadge } = props

  if (!badges.length) {
    return null
  }

  return (
    <Badges>
      <div data-type='title-section'>
        <h6 className='defaultTypographyH6'>Artist Recognition</h6>
      </div>
      {replaceBadges(badges).map(({ image, title }, key) => {
        return (
          <Badge
            key={title + key}
            justify='flex-start'
            align='center'
            onClick={() => clickArtistBadge(title)}
          >
            <img className='lazyload' data-src={image} alt={`link - ${title}`} />
            <div data-type='badge-description'>
              <p className='defaultTypographySmall'>{title}</p>
            </div>
          </Badge>
        )
      })}
    </Badges>
  )
})
